import React from 'react'
import { Badge } from 'react-bootstrap'

// The shared internal-note pair: the card tint (`internalNoteClassName`) and the badge beside the
// author's name. Warning-emphasis text on a warning-subtle fill measures 7.181:1 in light mode and
// 10.845:1 in dark mode, recorded at libs/webui/data-tools/src/DataTable/datatable.module.scss:20-56.
export const internalNoteClassName = 'border bg-warning-subtle text-warning-emphasis'

export const InternalNoteBadge = () => (
  <Badge bg="warning" text="dark" className="ms-2">
    Internal note
  </Badge>
)
